import type { Resource } from '../../';
export const country_search_placeholder: Resource = {"default":"Search countries"};
